"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Suggester = void 0;
const string_normalizer_1 = require("../../util/string-normalizer");
class Suggester {
    constructor(text, ignoreOptions) {
        this.text = text;
        this.normalizedText = string_normalizer_1.StringNormalizer.normalize(text, ignoreOptions);
        this.ignoreOptions = ignoreOptions;
    }
}
exports.Suggester = Suggester;
